import { render } from "./CallForPages.vue?vue&type=template&id=6d66f1df&scoped=true"
import script from "./CallForPages.vue?vue&type=script&lang=js"
export * from "./CallForPages.vue?vue&type=script&lang=js"

import "./CallForPages.vue?vue&type=style&index=0&id=6d66f1df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d66f1df"]])

export default __exports__